import React from "react";
import { ReactComponent as BackArrow } from "../../themes/Icons/back_arrow.svg";
import { theme as themeConfig } from "../../themes/themes";
import {
  ButtonBack,
  ContainerBack,
  ContentBack,
} from "./BackButtonComponent.styled";

const BackButtonComponent = ({
  backtitle,
  locationtitle,
  goToBackPage,
  titleColor,
  bgBack,
  titleSize,
  titleWeight,
  titleWidth,
  inactiveSlash,
  createTitle,
  identity,
}) => {
  return (
    <>
      <ContainerBack bgBack={bgBack}>
        <ContentBack props={identity}>
          <ButtonBack
            className="m-3"
            onClick={() => goToBackPage()}
            applyMargin={identity === "UserManagementDownload" ? true : false}
          >
            <BackArrow></BackArrow>
          </ButtonBack>
          <span
            style={{
              color: titleColor ? titleColor : themeConfig.text.disabled,
              fontSize: titleSize ? titleSize : "inherit",
              fontWeight: titleWeight ? titleWeight : "inherit",
              width: titleWidth ? titleWidth : "145px",
              // textOverflow: (identity !== "createSpace" || identity !== "surveyReports") ? "ellipsis" : "",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            {`${backtitle}`}
          </span>{" "}
          {locationtitle && (
            <span
              style={{
                width: titleWidth ? titleWidth : "110px",
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
                fontSize: titleSize ? titleSize : "inherit",
                fontWeight: titleWeight ? titleWeight : "inherit",
              }}
            >
              <span style={{ color: themeConfig.text.disabled }}>
                {inactiveSlash ? "|" : "/"}
              </span>{" "}
              {`${locationtitle}`}
            </span>
          )}
          {createTitle && (
            <span
              style={{
                width: titleWidth ? titleWidth : "110px",
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
                fontSize: titleSize ? titleSize : "inherit",
                fontWeight: 700,
              }}
            >
              <span style={{ color: themeConfig.text.disabled }}>
                {inactiveSlash ? "|" : "/"}
              </span>{" "}
              {`${createTitle}`}
            </span>
          )}
        </ContentBack>
      </ContainerBack>
    </>
  );
};

export default BackButtonComponent;
